import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Nav, NavItem, Row, NavLink, TabContent, TabPane, Form, Label, Input, FormFeedback } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone"
import { useParams } from 'react-router-dom';
import { useCommonDataFindAllQuery, useWellUpdateMutation, useWellFindAllQuery } from "store";
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import Measurement from "./Measurement";
import UsageIndex from "Components/Usage/Index";
import SafetyIndex from "Components/Safety/Index";
import OwnerIndex from "Components/Owner/Index";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import WaterBearing from "./WaterBearing";
import Flatpickr from "react-flatpickr";


const UgWellShow = () => {

  const { id } = useParams();

  const [activeTab, setactiveTab] = useState("1");
  const [baseMap, setBaseMap] = useState("google")
  const { data, error, isFetching } = useWellFindAllQuery(`/${id}`);
  const [wellMainData, setWellMainData] = useState<any>();
  const [wellGeom, setWellGeom] = useState<any>();
  const [customCenter, setCustomCenter] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  const [wellUpdate, wellUpdateResult] = useWellUpdateMutation();

  const [mineralBoolean, setMineralBoolean] = useState<boolean>(false);
  const [save_border, setSave_border] = useState<boolean>(false);

  const {
    data: groundwaterType,
    error: groundwaterTypeError,
    isFetching: isGroundwaterTypeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_well_type`);

  const {
    data: costType,
    error: costTypeError,
    isFetching: isCostTypeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  useEffect(() => {
    setWellMainData(data?.data)

    const tempMineral = wellMainData !== null ? wellMainData?.is_mineral : false;
    setMineralBoolean(tempMineral)

    const tempSave_border = wellMainData !== null ? wellMainData?.save_border : false;
    setSave_border(tempSave_border)

    setWellGeom(wellMainData?.geom)
    const tempCenter = { cusCenter: wellGeom?.coordinates };
    setCustomCenter(tempCenter);

  }, [wellGeom, wellMainData, data])

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: wellMainData?.id,
      code: wellMainData?.code,
      is_allowed: wellMainData?.is_allowed,
      cmn_well_type: wellMainData?.cmn_well_type,
      decision_info: wellMainData?.decision_info,
      building_design: wellMainData?.building_design,
      budget_cost: wellMainData?.budget_cost,
      cmn_invesetment_source: wellMainData?.cmn_invesetment_source,
      used_date: wellMainData?.used_date,
      drilled_organization_description: wellMainData?.drilled_organization_description,
      sea_level_m: wellMainData?.sea_level_m,
      save_border_desicion: wellMainData?.save_border_desicion,
      location: wellMainData?.location,

      au1_name: wellMainData?.au1_name,
      au2_name: wellMainData?.au2_name,
      au3_name: wellMainData?.au3_name,
      latitude: wellMainData?.latitude,
      longitude: wellMainData?.longitude,
      elevation: wellMainData?.elevation,

    },
    validationSchema: Yup.object({
      code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_well_type: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      decision_info: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      building_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      used_date: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      drilled_organization_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sea_level_m: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      formData.append('id', wellMainData ? wellMainData.id.toString() : '0');
      formData.append('code', values?.code);
      formData.append('cmn_well_type', values?.cmn_well_type);
      formData.append('is_mineral', String(mineralBoolean ?? false));
      formData.append('save_border', String(save_border ?? false));
      formData.append('decision_info', values?.decision_info);
      formData.append('building_design', values?.building_design);
      formData.append('budget_cost', values?.budget_cost);
      formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
      formData.append('used_date', values?.used_date);
      formData.append('drilled_organization_description', values?.drilled_organization_description);
      formData.append('sea_level_m', values?.sea_level_m);
      formData.append('save_border_desicion', values?.save_border_desicion);
      formData.append('location', values?.location);

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`shapes`, file);
        });
      }

      wellUpdate(formData);
      validation.resetForm();
      setResetFiles(true);
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Газрын доорх ус" breadcrumbItem="Худаг" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                        <span className="d-none d-sm-block">Үндсэн бүртгэл</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                        <span className="d-none d-sm-block">Хэмжилт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                        <span className="d-none d-sm-block">Хийц</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Ашиглалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          toggle("5");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Хамгаалалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Эзэмшигч</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Бүртгэлийн дугаар  *</Label>
                              <Input
                                name="code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                    validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.code &&
                                validation.errors.code ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Батлагдсан шийдвэр *</Label>
                              <Input
                                name="decision_info"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.decision_info || ""}
                                invalid={
                                  validation.touched.decision_info && validation.errors.decision_info
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.decision_info && validation.errors.decision_info ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.decision_info}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Байршил *</Label>
                              <Input
                                name="location"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.location}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Огноо *</Label>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Огноо"
                                name="used_date"
                                value={validation.values.used_date}
                                onChange={(selectDate: Date[]) => {
                                  if (selectDate[0]) {
                                    const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                                      .toISOString()
                                      .split('T')[0];
                                    validation.setFieldValue('used_date', localDate);
                                  }
                                }}
                                options={{
                                  altInput: true,
                                  altFormat: "Y-m-d",
                                  dateFormat: "Y-m-d",
                                  enableTime: false,
                                }}
                              />
                              {validation.touched.used_date && validation.errors.used_date ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.used_date}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүстэй эсэх*</Label> <br />
                              <Switch
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                className="me-1 mb-sm-8 mb-2 ms-3"
                                onColor="#626ed4"
                                onChange={() => {
                                  setSave_border(!save_border);
                                }}
                                checked={save_border}
                              />
                            </div>

                            <div className="mb-3">
                              <Label >Аймаг, нийслэл</Label>
                              <Input
                                name="au1_name"
                                disabled
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au1_name || ""}
                                invalid={
                                  validation.touched.au1_name && validation.errors.au1_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au1_name && validation.errors.au1_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au1_name}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label >Өндөршилт, Z</Label>
                              <Input
                                disabled
                                name="elevation"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.elevation || ""}
                                invalid={
                                  validation.touched.elevation && validation.errors.elevation
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.elevation && validation.errors.elevation ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.elevation}
                                </FormFeedback>
                              ) : null}
                            </div>


                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger"> Ордны төрөл *</Label>
                              <Input
                                name="cmn_well_type"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_well_type || ""}
                                invalid={
                                  validation.touched.cmn_well_type &&
                                    validation.errors.cmn_well_type
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {groundwaterType?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_well_type &&
                                validation.errors.cmn_well_type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_well_type}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Рашаан эсэх*</Label> <br />
                              <Switch
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                className="me-1 mb-sm-8 mb-2 ms-3"
                                onColor="#626ed4"
                                onChange={() => {
                                  setMineralBoolean(!mineralBoolean);
                                }}
                                checked={mineralBoolean}
                              />
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Төсөв өртөг *</Label>
                              <Input
                                name="budget_cost"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.budget_cost || ""}
                                invalid={
                                  validation.touched.budget_cost && validation.errors.budget_cost
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.budget_cost && validation.errors.budget_cost ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.budget_cost}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Зөвшөөрөлтэй эсэх *</Label>
                              <Input
                                name="is_allowed"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.is_allowed || ""}
                                invalid={
                                  validation.touched.is_allowed &&
                                    validation.errors.is_allowed
                                    ? true
                                    : false
                                }
                              >
                                <option value="">Тодорхойгүй</option>
                                <option value="false">Зөвшөөрөлгүй</option>
                                <option value="true">Зөвшөөрөлтэй</option>
                              </Input>
                              {validation.touched.is_allowed &&
                                validation.errors.is_allowed ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.is_allowed}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">	Мэргэжлийн байгууллага *</Label>
                              <Input
                                name="drilled_organization_description"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.drilled_organization_description || ""}
                                invalid={
                                  validation.touched.drilled_organization_description && validation.errors.drilled_organization_description
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.drilled_organization_description && validation.errors.drilled_organization_description ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.drilled_organization_description}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label>Сум, дүүрэг</Label>
                              <Input
                                disabled
                                name="au2_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au2_name || ""}
                                invalid={
                                  validation.touched.au2_name && validation.errors.au2_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au2_name && validation.errors.au2_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au2_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label>Баг/Хороо</Label>
                              <Input
                                disabled
                                name="au3_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au3_name || ""}
                                invalid={
                                  validation.touched.au3_name && validation.errors.au3_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au3_name && validation.errors.au3_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au3_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Далайн түвшинээс дээш метр *</Label>
                              <Input
                                name="sea_level_m"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sea_level_m || ""}
                                invalid={
                                  validation.touched.sea_level_m && validation.errors.sea_level_m
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sea_level_m}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>
                              <Input
                                name="save_border_desicion"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.save_border_desicion || ""}
                                invalid={
                                  validation.touched.save_border_desicion && validation.errors.save_border_desicion
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.save_border_desicion}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>
                              <Input
                                name="building_design"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.building_design || ""}
                                invalid={
                                  validation.touched.building_design && validation.errors.building_design
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.building_design && validation.errors.building_design ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.building_design}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Төсвийн үүсвэр*</Label>
                              <Input
                                name="cmn_invesetment_source"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_invesetment_source || ""}
                                invalid={
                                  validation.touched.cmn_invesetment_source &&
                                    validation.errors.cmn_invesetment_source
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {costType?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_invesetment_source &&
                                validation.errors.cmn_invesetment_source ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_invesetment_source}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол Х</Label>
                              <Input
                                disabled
                                name="latitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.latitude || ""}
                                invalid={
                                  validation.touched.latitude && validation.errors.latitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.latitude && validation.errors.latitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.latitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label >Солбицол У</Label>
                              <Input
                                disabled
                                name="longitude"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.longitude || ""}
                                invalid={
                                  validation.touched.longitude && validation.errors.longitude
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.longitude && validation.errors.longitude ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.longitude}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'point'} />
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div className='mapTypeSelection'>
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                            </div>
                            <MainMap baseMap={baseMap} results={wellGeom} customCenter={customCenter} zoomChange={15} type={'point'} />
                          </Col>

                        </Row>

                        <Row>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary"> Хадгалах </button>
                          </Col>
                        </Row>
                      </Form>

                    </TabPane>
                    <TabPane tabId="2">
                      <Measurement />
                    </TabPane>
                    <TabPane tabId="3">
                      <WaterBearing id={id} />
                    </TabPane>
                    <TabPane tabId="4">
                      <UsageIndex id={id} table_name={'well'} />
                    </TabPane>
                    <TabPane tabId="5">
                      <SafetyIndex id={id} table_name={'well'} />
                    </TabPane>
                    <TabPane tabId="6">
                      <OwnerIndex id={id} table_name={'well'} />
                    </TabPane>

                  </TabContent>
                </CardBody>
              </Card>
            </Col>


          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UgWellShow;